import React, { useEffect, useState } from "react";
import "./CatchPage.scss";
import CatchForm from "../../forms/CatchForm";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { connect, useSelector } from "react-redux";
import { handleGearPreferenceChange } from "../../constants/Effort";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { validateCatch } from "../../constants/catchValidations";
import { getCurrentOpenTrip, getTripValues } from "../../constants/vtrTrip";
import DefaultButton from "../../components/DefaultButton";
import { Navigate, useLocation } from "react-router-dom";
import TitleBar from "../../components/TitleBar";
import { Box, Grid } from "@mui/material";
import { success } from "../../constants/colors";
import { getRequiredUom } from "../../constants/Catch";
import DeleteCatch from "./DeleteCatch";

function CatchPage(props) {
  const { vtrTrip, auth, validation, helpText } = useSelector((state) => state);
  const { actions } = props;
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({
    species: "",
    kept: "",
    discarded: "",
    uom: "",
    default_species_uom: "",
    isLoaded: false,
    isExisting: false,
    report_type: null,
    trip_type: null,
  });

  const handleSpeciesChange = (event, reason) => {
    event.preventDefault();
    let newValue = {
      species: "",
      speciesName: "",
      uom: values.uom,
    };
    if (reason) {
      // * Save the new values when selected
      newValue.species = reason.SPPCODE;
      newValue.speciesName = reason.SPPNAME;
      const requiredUOM = getRequiredUom(
        reason.SPPCODE,
        validation.validations.species
      );
      if (requiredUOM) {
        newValue.uom = requiredUOM;
      } else {
        newValue.uom = values.default_species_uom;
      }
      // * Checking if species code is 'NC' to clear fields
      if (newValue.species === "NC") {
        newValue.kept = "0";
        newValue.discarded = "0";
      }
    }
    setValues({ ...values, ...newValue });
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const regex = /^[0-9]{0,8}$/;
    if (value === "" || regex.test(value)) {
      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  const _showConfirm = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    let errors = validateCatch(values);
    actions.setError(errors);
    if (errors.length > 0) {
      console.log("catchPage", errors);
      return;
    }
    if (value === "Save") {
      actions.updateCatch(
        values,
        auth.client_id,
        values.effort_id,
        values.catch_id
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (values.isLoaded === false) {
      const currentTrip = getCurrentOpenTrip(
        vtrTrip.allOpenTrips,
        location.state.trip_id
      );
      // * Assigned a default value to default_uom in case of an old trip
      // * in the user's homepage.
      const tripValues = getTripValues(
        currentTrip.trip_type,
        currentTrip.report_type,
        location.state.types
      );
      // * Assigned a default_species_uom in case of an old trip in the user's homepage.
      currentTrip.default_uom = tripValues.DEFAULT_UOM;
      currentTrip.default_species_uom = tripValues.DEFAULT_SPECIES_UOM;

      let effortNr = location.state.effortNr ? location.state.effortNr : 0;
      let catchNr = location.state.catchNr;
      let catchState = {
        species: "",
        kept: "",
        discarded: "",
        uom: currentTrip.default_uom,
        default_species_uom: currentTrip.default_species_uom,
        isLoaded: true,
        trip_id: currentTrip.trip_id,
        effort_id: effortNr,
        catch_id: catchNr,
        report_type: currentTrip.report_type,
        trip_type: currentTrip.trip_type,
      };
      if (
        currentTrip &&
        currentTrip.images &&
        currentTrip.images[effortNr] &&
        currentTrip.images[effortNr].catch &&
        currentTrip.images[effortNr].catch[catchNr]
      ) {
        let currentCatch = currentTrip.images[effortNr].catch[catchNr];
        if (currentCatch && currentCatch.hasOwnProperty("species")) {
          catchState.species = currentCatch.species;
          catchState.discarded = currentCatch.discarded;
          catchState.kept = currentCatch.kept;
          catchState.uom = currentCatch.uom;
          catchState.isExisting = true;
        }
        console.log("catchPage mount", currentTrip);
      }
      console.log("catchPage mount-state", catchState);
      setValues({ ...values, ...catchState });
    }
  }, [location, values, vtrTrip]);

  if (vtrTrip.redirect === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/effort-review`}
        state={{
          trip_id: values.trip_id,
          client_id: auth.client_id,
          effortNr: values.effort_id,
        }}
      />
    );
  }

  // * Effort catchitem bar with delete button
  return (
    <div className="CatchPage" data-testid="CatchPage">
      <TitleBar
        title="Effort Catch item"
        delete_button={values.isExisting === true ? _showConfirm : false}
        client_id={auth.client_id}
        trip_id={values.trip_id}
        effort_id={values.effort_id}
        catch_id={values.catch_id}
      />
      {open && (
        <DeleteCatch
          isVisible={open}
          setIsVisible={setOpen}
          client_id={auth.client_id}
          trip_id={values.trip_id}
          effortNr={values.effort_id}
          catchNr={values.catch_id}
          handleAction={actions.deleteCatch}
        />
      )}

      <CatchForm
        reportType={values.report_type}
        tripType={values.trip_type}
        handleChange={handleInputChange}
        speciesCode={values.species}
        speciesCodeChange={handleSpeciesChange}
        kept={values.kept}
        discarded={values.discarded}
        uom={values.uom}
        handleGearPreferenceChange={handleGearPreferenceChange}
        helpText={helpText.helpText}
      />

      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(CatchPage);
